export const GET_PRIORITIES_REQUEST = 'GET_PRIORITIES_REQUEST';
export const GET_PRIORITIES_SUCCESS = 'GET_PRIORITIES_SUCCESS';
export const GET_PRIORITIES_FAILURE = 'GET_PRIORITIES_FAILURE';

export const getPrioritiesRequest = (filters = {}) => ({
    type: GET_PRIORITIES_REQUEST,
    payload: {
        filters
    }
});

export const getPrioritiesSuccess = priorities => ({
    type: GET_PRIORITIES_SUCCESS,
    payload: {
        priorities
    }
});

export const getPrioritiesFailure = err => ({
    type: GET_PRIORITIES_FAILURE,
    error: err
});
